/**
 * Admin Staff Contracts - Database-First Zod Schemas
 *
 * SOURCE OF TRUTH: PostgreSQL tables
 * Generated from MCP queries on 2026-01-02
 *
 * Table schema (staff):
 * - identifier: varchar NOT NULL (PK) - obfuscated telegram_id
 * - role: varchar NOT NULL
 * - active: boolean DEFAULT true
 * - created_at: timestamptz DEFAULT now()
 * - last_active_date: date NULL
 *
 * Constraint: valid_role CHECK ((role)::text = ANY (ARRAY['super_admin', 'admin', 'worker', 'referee']))
 *
 * Table schema (bans):
 * - id: integer NOT NULL (serial PK)
 * - user_telegram_id: bigint NOT NULL
 * - staff_id: varchar NOT NULL
 * - action: varchar NOT NULL
 * - reason: text NULL
 * - created_at: timestamptz DEFAULT now()
 *
 * Constraints:
 * - valid_ban_action CHECK ((action)::text = ANY (ARRAY['ban', 'unban']))
 * - ban_requires_reason CHECK (((action)::text <> 'ban') OR (reason IS NOT NULL))
 */
import { z } from 'zod';
// =============================================================================
// DATABASE CONSTRAINTS
// =============================================================================
/**
 * Staff role values (matches staff.role CHECK constraint)
 * CHECK ((role)::text = ANY (ARRAY['super_admin', 'admin', 'worker', 'referee']))
 */
export const staffRoleValues = ['super_admin', 'admin', 'worker', 'referee'];
export const staffRoleSchema = z.enum(staffRoleValues);
// =============================================================================
// ENTITY SCHEMAS
// =============================================================================
/**
 * Staff table entity
 * Full row from staff table
 */
export const staffEntitySchema = z.object({
    identifier: z.string(), // Obfuscated telegram_id
    role: staffRoleSchema,
    active: z.boolean().default(true),
    created_at: z.coerce.date(),
    last_active_date: z.coerce.date().nullable(),
});
/**
 * Bans table entity
 * Full row from bans table
 */
export const banEntitySchema = z.object({
    id: z.number().int(),
    user_telegram_id: z.coerce.bigint(),
    staff_id: z.string(),
    action: z.enum(['ban', 'unban']),
    reason: z.string().nullable(),
    created_at: z.coerce.date(),
});
// =============================================================================
// API RESPONSE SCHEMAS
// =============================================================================
/**
 * Staff member for admin panel display
 * Converts DB snake_case to camelCase
 */
export const staffMemberSchema = z.object({
    identifier: z.string(),
    role: staffRoleSchema,
    active: z.boolean(),
    createdAt: z.string(), // ISO string
    lastActiveDate: z.string().nullable(), // ISO date string
});
//# sourceMappingURL=staff.js.map